<div
	class="form-group"
	[formGroup]="OBJ_form_group">
	<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
	<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
		<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
		   [tooltip]="tooltipTemplate"
		   placement="top"
		   triggers="click"
		   containerClass="tig-tooltip"
		   delay="50"></i>
		<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
	<div class="col-lg-8">
		<ng-container *ngFor="let OBJ_link of this.OBJ_field_config.value | keyvalue">
			<a
				href="{{OBJ_link.value}}"
				target="_blank">{{OBJ_link.key}} <i class="fa fa-external-link"></i>
			</a>
		</ng-container>
	</div>
</div>
